/**
 * Nguồn duy nhất cho toàn bộ key lưu ở localStorage.
 * Không viết chuỗi key thẳng trong code — luôn tham chiếu qua đây để đổi 1 nơi là đủ.
 */
export const STORAGE_KEYS = {
  GROUP_ID: "groupId",
  LIBRARY_ID: "libraryId",
  WEB_KEY: "webKey",
  FINGERPRINT: "fingerprint",
  LOGIN_AUTH: "9yXw9iwEjl",
  THEME: "ui-theme",
} as const;
